import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export function LegalPage({ title, sections }) {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border">
        <div className="mx-auto flex h-16 max-w-3xl items-center justify-between px-6">
          <Logo />
          <Link to="/"><Button variant="ghost" size="sm"><ArrowLeft className="mr-1 h-4 w-4" /> Home</Button></Link>
        </div>
      </header>
      <div className="mx-auto max-w-3xl px-6 py-12">
        <h1 className="font-heading text-3xl font-semibold tracking-tight">{title}</h1>
        <p className="mt-2 text-sm text-muted-foreground">Ultimo aggiornamento: giugno 2026</p>
        <div className="mt-8 space-y-8">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-heading text-xl font-medium">{s.heading}</h2>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}

export function Terms() {
  return <LegalPage title="Termini di servizio" sections={[
    { heading: "1. Accettazione dei termini", body: "Utilizzando Connectivity accetti i presenti termini di servizio. Connectivity è una piattaforma SaaS multi-tenant per la gestione delle comunicazioni WhatsApp Business." },
    { heading: "2. Account e sicurezza", body: "Sei responsabile della riservatezza delle credenziali del tuo account e di tutte le attività svolte tramite esso. Ogni azienda costituisce un tenant separato con dati isolati." },
    { heading: "3. Uso consentito", body: "Ti impegni a utilizzare la piattaforma nel rispetto delle normative applicabili e delle policy di WhatsApp Business, senza inviare comunicazioni non autorizzate." },
    { heading: "4. Limitazioni di responsabilità", body: "Il servizio è fornito 'così com'è'. In questa fase alcune funzionalità (es. integrazione Meta WhatsApp) sono predisposte ma non ancora attive." },
    { heading: "5. Modifiche", body: "Ci riserviamo il diritto di aggiornare questi termini. Le modifiche saranno comunicate tramite la piattaforma." },
  ]} />;
}

export function Privacy() {
  return <LegalPage title="Informativa privacy" sections={[
    { heading: "1. Titolare del trattamento", body: "I dati personali sono trattati nel rispetto del GDPR. Ogni tenant è titolare dei dati dei propri contatti e utenti." },
    { heading: "2. Dati raccolti", body: "Raccogliamo dati di registrazione (nome, email, azienda), dati di utilizzo e log di sicurezza (IP, user agent) per garantire la protezione degli account." },
    { heading: "3. Finalità", body: "I dati sono utilizzati per fornire il servizio, garantire la sicurezza, tracciare le attività tramite audit log e migliorare la piattaforma." },
    { heading: "4. Conservazione e sicurezza", body: "Le password sono memorizzate tramite hash sicuri. Le API key sono salvate solo come hash. I token di reset e invito hanno scadenza." },
    { heading: "5. Diritti dell'interessato", body: "Puoi esercitare i diritti di accesso, rettifica e cancellazione dei tuoi dati contattando il titolare del tenant." },
  ]} />;
}
